var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoAttachment24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_attachment24x24",
    transform: "translate(-2.994 -2.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M466.919,154.765c.161.022.322.04.482.067a4.213,4.213,0,0,1,3.448,3.475,4.134,4.134,0,0,1-1.2,3.721q-2.537,2.556-5.092,5.1l-2.381,2.379a4.065,4.065,0,0,1-2.326,1.2,4.147,4.147,0,0,1-3.949-1.47,3.982,3.982,0,0,1-.967-2.374,4.185,4.185,0,0,1,1.269-3.387c.245-.246.492-.49.738-.736.019-.019.038-.036.074-.068a3.856,3.856,0,0,0,.762,2.269.954.954,0,0,0-.135.1,2.044,2.044,0,0,0-.489,2.141,2.119,2.119,0,0,0,3.51.834q1.954-1.939,3.893-3.889l3.59-3.588a2.122,2.122,0,0,0-1.11-3.616,2.089,2.089,0,0,0-1.893.615q-2.374,2.373-4.747,4.748a.546.546,0,0,0-.178.554.523.523,0,0,0,.872.247c.452-.438.888-.888,1.337-1.333l2.36-2.361c.02-.02.043-.04.069-.064a2.021,2.021,0,0,1,.428.611,2.112,2.112,0,0,1-.4,2.36q-1.138,1.155-2.293,2.291a2.6,2.6,0,0,1-2.092.753,2.655,2.655,0,0,1-2.393-2.257,2.591,2.591,0,0,1,.756-2.269q2.412-2.424,4.837-4.835a4.108,4.108,0,0,1,2.482-1.184c.076-.009.153-.02.229-.031Z",
    transform: "translate(-451.922 -151.765)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoAttachment24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_attachment24x24.c1ffe7cb4d283a8b6d1e226d9bd86a8c.svg";